import { useState, useEffect } from 'react'
import Wrapper from 'components/Wrapper/Wrapper'
import Text from 'components/common/BaseText/BaseText'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/scss'

import './About.scss'

const slides = [
	{
		image: 'https://randomuser.me/api/portraits/women/42.jpg',
		opinion:
			"You're a fantastic frontend developer! Your attention to detail and ability to translate designs into beautiful and functional websites is impressive.",
		name: 'Sarah Johnson',
		profession: 'UX Designer',
	},
	{
		image: 'https://randomuser.me/api/portraits/men/84.jpg',
		opinion:
			"I've had the privilege of working with you on a few projects now, and I have to say, you're a top-notch frontend developer. Your code is clean, efficient, and a pleasure to work with.",
		name: 'John Doe',
		profession: 'Software Engineer',
	},
	{
		image: 'https://randomuser.me/api/portraits/women/24.jpg',
		opinion:
			"You're a natural when it comes to frontend development. Your creative solutions and ability to think outside the box never cease to amaze me.",
		name: 'Emily Brown',
		profession: 'Product Manager',
	},
	{
		image: 'https://randomuser.me/api/portraits/men/67.jpg',
		opinion:
			'You have a real talent for frontend development. Your ability to bring ideas to life and create engaging user experiences is truly remarkable.',
		name: 'Michael Davis',
		profession: 'Full Stack Developer',
	},
]

const About: React.FC = () => {
	const [windowSize, setWindowSize] = useState({ height: window.innerHeight, width: window.innerWidth })

	const isMobile = windowSize.width <= 768
	const isTablet = windowSize.width > 768 && windowSize.width <= 992
	const isDesktop = windowSize.width > 992

	let slidesPerView

	if (isMobile) {
		slidesPerView = 1.2
	} else if (isTablet) {
		slidesPerView = 1.8
	} else if (isDesktop) {
		slidesPerView = 2.4
	}

	useEffect(() => {
		const handleResize = () => {
			setWindowSize({ height: window.innerHeight, width: window.innerWidth })
		}
		window.addEventListener('resize', handleResize)
	}, [])

	return (
		<Wrapper className='about' id='about'>
			<div className='about__container-title'>
				<h3 className='about__title'>People talk about me</h3>
				<Text>
					I always wanted my work to be part of a bigger one, to make people's daily lives and complex application
					simple to use.
				</Text>
			</div>
			<div className='about__slider'>
				<Swiper
					spaceBetween={isMobile ? 16 : 32}
					slidesOffsetBefore={isMobile ? 26 : 0}
					slidesOffsetAfter={isMobile ? 26 : 0}
					slidesPerView={slidesPerView}
					scrollbar={{ draggable: true }}
					onSlideChange={() => {}}
					onSwiper={() => {}}>
					{slides.map(({ image, opinion, name, profession }) => {
						return (
							<SwiperSlide key={name}>
								<div className='slider__card'>
									<div className='card__container-img'>
										<img className='card__img' src={image} alt={name}></img>
									</div>
									<p className='card__opinion'>{opinion}</p>
									<p className='card__name'>{name}</p>
									<p className='card__proffesion'>{profession}</p>
								</div>
							</SwiperSlide>
						)
					})}
				</Swiper>
			</div>
		</Wrapper>
	)
}

export default About
